import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";

const baseURL = process.env.REACT_APP_FMS_API + '/transactions/orderOfPayments';

export const orderOfPaymentsAPI = createStaticResourceAPI({
  baseURL: baseURL,
  resource: "OrderOfPayments",
  tagTypes: ["OrderOfPayments"],
  idKey: "orderOfPaymentId",
  lookupMap: ({ orderOfPaymentId, referenceNo }) => ({
    value: orderOfPaymentId,
    label: referenceNo
  }),
  customQuery: (query, { idKey, resource, baseURL }) => ({
    getListOrderOfPaymentsForViewers: query(`${baseURL}/listForViewer`, {
      serializeQueryArgs: ({ endpointName }) => endpointName,
      providesTags: (result) => result?.success
        ? [
          ...result.returnData?.map(item => ({
            type: resource,
            id: item[idKey],
          })),
          { type: resource, id: "LIST" },
        ]
        : [{ type: resource, id: "LIST" }],
    }),
  }),
  customMutations: (mutation, mutationOptions) => ({
    submitOrderOfPayments: mutation(`${baseURL}/submit`, mutationOptions("save")),
    returnOrderOfPayments: mutation(`${baseURL}/return`, mutationOptions("save")),
    approveOrderOfPayments: mutation(`${baseURL}/approve`, mutationOptions("save")),
    rejectOrderOfPayments: mutation(`${baseURL}/reject`, mutationOptions("save")),
    cancelOrderOfPayments: mutation(`${baseURL}/cancel`, mutationOptions("save")),
  }),
});

export const {
  useGetOrderOfPaymentsQuery,
  useListOrderOfPaymentsForViewersQuery,
  useExportOrderOfPaymentsMutation,
  useFindOrderOfPaymentsQuery,
  useLookUpOrderOfPaymentsMutation,
  useSaveOrderOfPaymentsMutation,
  useSubmitOrderOfPaymentsMutation,
  useReturnOrderOfPaymentsMutation,
  useApproveOrderOfPaymentsMutation,
  useRejectOrderOfPaymentsMutation,
  useCancelOrderOfPaymentsMutation,
  useDeleteOrderOfPaymentsMutation
} = orderOfPaymentsAPI;
